import React, { useState } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Modal, Button, Alert } from "react-bootstrap";
import MonitorTemperature from "../../../../../monitor/pages/Monitor/Temperatures/Temperatures";
import { routes } from "@common/constants/urls";
import * as sessionService from "@brewery/services/sessionService";
import "./status-active.scss";

const StatusActive = ({ currentTemp, targetTemp, sessionId, dispatch }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleSkipToServing = () => {
    if (loading) return;
    setLoading(true);
    setError(false);
    sessionService
      .updateSession(sessionId, { command_type: 0 })
      .then(() => {
        setShowModal(false);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="device__status--active">
      <div
        onClick={() => dispatch(push(routes.monitoring + sessionId))}
        className="device__status--active-main"
      >
        <div className="device__temp">
          <MonitorTemperature current={currentTemp} target={targetTemp} />
        </div>
        <span className="ion-ios-arrow-right device__chevron" />
      </div>
      {/* {isFermenting && (
        <div
          className="device__skip-to-serving"
          onClick={e => { e.stopPropagation(); setShowModal(true); }}
        >
          Skip to serving →
        </div>
      )} */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ textAlign: "center" }}>
            Skip to Serving?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span style={{ fontFamily: "Gotham-Book" }}>
            Are you sure you want to skip fermentation and go straight to
            serving? Make sure fermentation is complete before switching —
            skipping early may affect carbonation and final flavour.
          </span>
          {error && (
            <Alert bsStyle="danger" style={{ marginTop: "12px" }}>
              <span className="ion-alert-circled">
                {" "}
                Something went wrong, please try again.
              </span>
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          {loading && (
            <span
              className="start-brew-loading__icon ion-load-c spin"
              style={{ float: "left", marginTop: "6px" }}
            >
              {" "}
              Switching to serving...
            </span>
          )}
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button
            onClick={handleSkipToServing}
            bsStyle="primary"
            disabled={loading}
          >
            Skip to Serving
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default connect(
  undefined,
  undefined
)(StatusActive);
